import * as React from "react";
import classNames from "classnames";

const Gallery: React.FC<{ isCentered?: boolean }> = ({ children, isCentered }) => {
    return (
        <div
            className={classNames("gallery", {
                "gallery--isCentered": isCentered
            })}
        >
            {children}
        </div>
    );
};

export default Gallery;
